import LandingFrame from "./components/LandingFrame";
import UserAccountRoutes from "../front_user_account/routes";

export default [
    {
        path: "/",
        name: "landing",
        meta: {
            auth: undefined,
            basePath: false,
        },
        component: LandingFrame,
        children: [...UserAccountRoutes],
    },
];
